<user-navigation></user-navigation>

<div class="container-fluid">
    <div class="row no-gutter">
        <div class="col-md-4">
            <div class="default-box long-form d-flex align-items-center">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-lg-4 col-xl-4 mx-auto side-nav">
                            <div id="page-redirection">
                                <a routerLink="/user/profile"> 
                                    <img src="../../../../assets/images/arrow-left.png">
                                    Back to Account
                                </a>
                            </div>
                            <h3 class="display-4 box-title mt-4 mt-md-4">Change Email</h3>
                            <form action="profile.html">
                                <div class="md-input">
                                    <input class="md-form-control" required type="email" readonly [value]="email">
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Current Email</label>
                                </div>
                                <div class="md-input">
                                    <input class="md-form-control" required type="password">
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>New Email</label>
                                </div>

                                <button type="submit" class="btn btn-primary btn-block btn-submit">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-8 d-none d-md-flex default-box bg-image-user"></div>
    </div>
</div>
